export const AIM_MANUAL_FLOW_ALLOWED_PROTOCOLS = {
  '1': 'ICMP',
  '6': 'TCP',
  '17': 'UDP',
  '58': 'ICMPv6',
};
